<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../assets/footer-logo.webp" alt="PHONPHAI INNOVATION PRIVATE LIMITED Logo" />
            <div class="logo-text">PHONPHAI INNOVATION PRIVATE LIMITED</div>
        </div>
        <div class="contact-list">
            <div class="contact" v-for="(item, index) in list" :key="index">
                <img class="item-icon" :src="item.icon" alt="">
                <div class="item-text">{{ item.title }}</div>
            </div>
        </div>
        <div class="bottom">
            © 2025 PHONPHAI INNOVATION PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        title: 'company@phonphai-innovation.com',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: `3th floor 3rdFLOOR JMD, DLF QE, Dlf Qe, Gurgaon- 122002, Haryana`,
        icon: require('../assets/footer-icon2.webp')
    },
    {
        title: '+91 7739633527',
        icon: require('../assets/footer-icon3.webp')
    },
]
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    padding: 0 270px;
    box-sizing: border-box;
    background: #545454;

    .logo-box {
        padding-top: 37px;
        display: flex;
        align-items: center;
        margin-bottom: 37px;

        .logo {
            width: 60px;
            height: 60px;
            object-fit: cover;
            margin-right: 17px;
        }

        .logo-text {
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .contact-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 59px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .contact {
            display: flex;
            justify-content: start;
            align-items: center;

            .item-icon {
                width: 18px;
                height: 18px;
                object-fit: contain;
                margin-right: 8px;
            }

            .item-text {
                max-width: 215px;
                font-weight: 400;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 14px;
                text-shadow: 0px 1px 0px #333333;
            }
        }
    }

    .bottom {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 18px;
        text-shadow: 0px 1px 0px #333333;
        padding: 15px 0;
        text-align: center;
    }
}
</style>